export const BLOCK_HEIGHT = 208;
export const BLOCK_HEIGHT_COMPACT = 180;

export const BLOCK_HEIGHT_VIDEO = 120;
export const BLOCK_HEIGHT_VIDEO_COMPACT = 80;

export const blockHeight = ({compact, type}) => {
  switch (type) {
    case 'video':
      return compact ?
        BLOCK_HEIGHT_VIDEO_COMPACT :
        BLOCK_HEIGHT_VIDEO;
    default:
      return compact ?
        BLOCK_HEIGHT_COMPACT :
        BLOCK_HEIGHT;
  }
};

export const padding = ({compact}) => (
  compact ? 16 : 24
);



// WEBPACK FOOTER //
// ./src/elements/Card/constants.js